import { render, staticRenderFns } from "./itemClient.vue?vue&type=template&id=61e7d606&scoped=true&"
import script from "./itemClient.vue?vue&type=script&lang=js&"
export * from "./itemClient.vue?vue&type=script&lang=js&"
import style0 from "./itemClient.vue?vue&type=style&index=0&id=61e7d606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7d606",
  null
  
)

export default component.exports